import "../style.css"
import "../components/data-view"
import { setupViewTitle } from "../view-title"
import { joinAsView } from "../view-registry"
import { bootstrapStoreState } from "../store-state"
import dataManifest from "../views/data.manifest"

setupViewTitle(dataManifest)
joinAsView(dataManifest)
void bootstrapStoreState()
